<template>
  <div>
    <b-sidebar
      :visible="visible"
      no-close-on-esc
      :no-close-on-backdrop="noCloseOnBackdrop"
      :backdrop="backdrop"
      :shadow="shadow"
      bg-variant="white"
      :sidebar-class="`${baseClass} width-${width} left-sidebar`"
      :header-class="`${baseClass}__header left-sidebar__header ${headerClass}`"
      :body-class="`${baseClass}__body left-sidebar__body ${bodyClass}`"
      :footer-class="`${baseClass}__footer left-sidebar__footer`"
      @hidden="handleHidden"
    >
      <template #header>
        <div :class="`left-sidebar__right-header`">
          <span
            v-if="hasHeaderRightIcon"
            class="left-sidebar__icon"
            @click="hasBack ? handleBack() : handleClose()"
          >
            <mdicon :name="hasBack ? 'arrow-right' : 'close'" size="24" />
          </span>
          <span class="left-sidebar__title" v-html="title"></span>
        </div>
        <slot name="left-header-content"></slot>
      </template>
      <template #default>
        <slot name="default"></slot>
      </template>
      <template #footer>
        <slot v-if="hasFooter" name="footer"></slot>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { toRefs } from "vue";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    backdrop: {
      type: Boolean,
      default: false,
    },
    shadow: {
      type: Boolean,
      default: false,
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: true,
    },
    baseClass: {
      type: String,
      default: "left-filter",
    },
    hasHeaderRightIcon: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    hasBack: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: 350,
    },
    headerClass: {
      type: String,
      default: "",
    },
    bodyClass: {
      type: String,
      default: "",
    },
    hasFooter: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const {
      visible,
      backdrop,
      shadow,
      noCloseOnBackdrop,
      baseClass,
      hasHeaderRightIcon,
      title,
      hasBack,
      width,
      headerClass,
      hasFooter,
    } = toRefs(props);

    const handleHidden = () => emit("hidden");
    const handleBack = () => emit("back");
    const handleClose = () => emit("close");

    // return data to be used in template
    return {
      visible,
      backdrop,
      shadow,
      noCloseOnBackdrop,
      baseClass,
      hasHeaderRightIcon,
      title,
      hasBack,
      width,
      headerClass,
      hasFooter,
      handleHidden,
      handleBack,
      handleClose,
    };
  },
};
</script>
